module.exports = __webpack_public_path__ + "img/bill.3f91e6be.png";